import { LeadClient } from './lead.client.model';

export class LeadClientsGroup {
    constructor(
        public date?: string,
        public leadClients?: LeadClient[],
    ) {
    }
}
